import React from 'react';
import { Link } from 'react-router';
import moment from 'moment';

const BlogPost = ({key, blog, t}) => {
    const { name, slug, category, author = "Luca Fantin", published_at, path } = blog || {};

    return (
        <article key={key} className="bg-white rounded-lg overflow-hidden">
            <Link to={`/blog_detail/${slug}`} className="block">
                <div className="relative h-64 overflow-hidden">
                    <img
                        src={path}
                        alt={name}
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 flex justify-center">
                        <span className="bg-white text-[#C7702A] px-3 py-2 text-sm font-['Jost',_sans-serif] font-semibold tracking-[0.48px]">
                            {category?.name}
                        </span>
                    </div>
                </div>
            </Link>
            <div className="p-6">
                <h3 className="font-['Libre_Caslon_Caption'] text-[32px] font-normal leading-[38px] mb-2 text-center">
                    <Link to={`/blog_detail/${slug}`} className="text-[#1F0707aa] hover:text-[#D3752B] transition-colors duration-300">
                        {name}
                    </Link>
                </h3>
                <div className="flex items-center justify-center text-[14px] text-[#1F070799] mb-4">
                    <span className="mr-4 font-['Jost',_sans-serif] font-normal">by {author}</span>
                    <span className="font-['Jost',_sans-serif] font-normal">{moment(published_at).format("MMM DD, YYYY")}</span>
                </div>
                <div className="flex items-center justify-center text-[14px] text-[#1F070799] mb-4">
                    <Link to={`/blog_detail/${slug}`} className="text-[#D3752B] transition-colors duration-300 text-right">
                        {t?.readMore}
                    </Link>
                </div>
            </div>
        </article>
    );
};

export default BlogPost;